import DOMPurify from 'dompurify'

const DEFAULT_SANITIZATION_CONFIG = {
    ALLOWED_TAGS: ['strong', 'em', 'u', 's', 'ol', 'ul', 'li', 'a', 'img', 'p'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'title'],
    ADD_ATTR: ['target', 'rel', 'alt', 'title'],
    ADD_DATA_URI_TAGS: [],
}

/**
 * Sanitizes HTML content to allow only safe formatting tags and links.
 * @param html - The HTML string to sanitize
 * @returns Sanitized HTML string
 */
export function sanitizeHtmlContent(html: string, allowImages = true): string {
    const config = allowImages
        ? DEFAULT_SANITIZATION_CONFIG
        : {
              ...DEFAULT_SANITIZATION_CONFIG,
              ALLOWED_TAGS: DEFAULT_SANITIZATION_CONFIG.ALLOWED_TAGS.filter((tag) => tag !== 'img'),
              ALLOWED_ATTR: DEFAULT_SANITIZATION_CONFIG.ALLOWED_ATTR.filter((attr) => attr !== 'src' && attr !== 'alt'),
          }

    return DOMPurify.sanitize(html, config)
}

/**
 * Sanitizes HTML content and removes all HTML tags, returning plain text.
 * Useful for calculating text length or displaying text-only content.
 *
 * @param html - The HTML string to sanitize and convert to plain text
 * @returns Plain text string with all HTML tags removed
 */
export function sanitizeToPlainText(html: string): string {
    const sanitized = DOMPurify.sanitize(html)

    return sanitized.replace(/<[^>]+>/g, '')
}
